import React from 'react'
import { GitHub } from '../icons/GitHub'
import { Button } from './Button'
import Link from 'next/link'

export function SignupButton(props) {
  return (
    <div className='flex flex-col sm:items-center'>
      <Link href='/api/auth/github'>
        <a
          className='block py-2 sm:py-4'
          style={{ textDecoration: 'none!important' }}
        >
          <Button {...props}>
            <GitHub className='w-6 h-6' />
            <span className='ml-3'>Signup with GitHub</span>
          </Button>
        </a>
      </Link>
      <span className='text-sm font-medium text-gray opacity-60 sm:-mt-2'>
        Free up to 5M req/mo · No CC required
      </span>
    </div>
  )
}
